// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__2fnLa","modalMain":"Modal_modalMain__1l2Yv","closeButton":"Modal_closeButton__1YmLm"};